var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-footer"},[_c('wStackedContentBanner',{attrs:{"heading":"About Us","subheading":"Who we are","image":"/images/about-assurity.png","alt":"","stackedContent":[
        {
          heading: 'Certified for good',
          content:
            '<p>As the largest insurance company to be a Certified B Corporation, we’re working to make business better for people and the planet. <a href=\'https://www.assurity.com/goodbusiness\' target=\'_blank\'>See how B Corps like Assurity are changing the world.</a></p>',
          image: '/images/bcorp.png',
          imageAlt:
            'Certified B corporation. This company meets the highest standards of social and environmental impact.',
          placeholder: { width: 200, height: 100 }
        },
        {
          heading: 'Award-winning service',
          content:
            '<p>There’s a reason Newsweek named our customer service among the best in America – you can manage your coverage online, or talk to a real person in Lincoln, Nebraska for help with whatever you need.</p>',
          image: '/images/newsweek2021.png',
          imageAlt: 'Newsweek, best life insurance customer service, 2021',
          placeholder: { width: 200, height: 94 }
        }
      ]}}),_c('a-dotted-line'),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"disclaimer-content"},[_c('disclaimers')],1),_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"copyright"},[_vm._v("© 2019 - "+_vm._s(new Date().getFullYear())+" Assurity Group, Inc.")]),_vm._m(0)])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legal"},[_c('a',{attrs:{"href":"https://www.assurity.com/legal-information"}},[_vm._v("Privacy & Consumer Notices")])])
}]

export { render, staticRenderFns }